import { useAuth } from 'react-oidc-context';
import { parseAccessToken } from '@/lib/auth-token';
import type { AuthUser } from '@/types/auth';

export function useAuthUser() {
  const auth = useAuth();
  const user: AuthUser | null = parseAccessToken(auth.user?.access_token);

  return {
    ...auth,
    user,
    emiratesId: user?.emiratesId ?? null,
    phoneNumber: user?.phoneNumber ?? null,
    fullNameEn: user?.fullNameEn ?? null,
    fullNameAr: user?.fullNameAr ?? null,
    email: user?.email ?? null,
  };
}
